/**
 * SLIMJACK Cookie-Consent – Banner-Logik (Teil 2 von 2)
 *
 * - zeigt Banner und Einstellungsdialog
 * - speichert die Auswahl (Cookie "sj_consent", 12 Monate)
 * - meldet die Auswahl an Shopify (Customer Privacy API) -> Shopify Analytics, Pixel und Apps richten sich danach
 * - aktualisiert den Google Consent Mode v2
 * - gibt blockierte Skripte frei: <script type="text/plain" data-sj-consent="analytics|marketing|preferences">
 * - hält Klaviyo-Popups zurück, bis der Besucher entschieden hat
 *
 * Einstellungen: Theme-Editor > Theme-Einstellungen > Cookie-Banner
 */
(function () {
  'use strict';

  var PENDING = 'sj-consent-pending';
  var KLAVIYO_SCROLL_LOCK = 'klaviyo-prevent-body-scrolling';

  var api = window.SJConsent;
  var root = document.getElementById('sj-consent');
  if (!api || !root) {
    document.documentElement.classList.remove(PENDING);
    return;
  }
  api._ready = true;

  var CATEGORIES = ['preferences', 'analytics', 'marketing'];
  var MAX_AGE = 60 * 60 * 24 * 365;
  var OPENERS = '[data-sj-consent-open], a[href$="#cookie-einstellungen"], a[href$="#cookie-settings"]';

  /* Cookies bekannter Dienste, die beim Widerruf einer Kategorie gelöscht werden */
  var CLEANUP = {
    analytics: [/^_ga/, /^_gid$/, /^_gat/, /^_hj/, /^_clck$/, /^_clsk$/],
    marketing: [/^_gcl_/, /^_fbp$/, /^_fbc$/, /^_ttp$/, /^_tt_enable_cookie$/, /^tt_/, /^_pin_unauth$/, /^__kla_id$/, /^_uet/]
  };

  var banner = root.querySelector('[data-sj-banner]');
  var prefs = root.querySelector('[data-sj-prefs]');
  var fab = root.querySelector('[data-sj-fab]');
  var bannerIsModal = root.getAttribute('data-modal') === 'true';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var lastFocus = null;

  function gtag() { window.dataLayer.push(arguments); }
  function state(granted) { return granted ? 'granted' : 'denied'; }

  /* ---------------------------------------------------------------------------------------------------------------
   * Speichern
   * ------------------------------------------------------------------------------------------------------------- */

  function persist(consent) {
    var value = JSON.stringify({
      v: api.version,
      p: consent.preferences ? 1 : 0,
      a: consent.analytics ? 1 : 0,
      m: consent.marketing ? 1 : 0,
      t: api.timestamp
    });
    try {
      document.cookie = api.cookieName + '=' + encodeURIComponent(value) + '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' +
        (window.location.protocol === 'https:' ? '; Secure' : '');
    } catch (e) {}
    try { window.localStorage.setItem(api.cookieName, value); } catch (e) {}
  }

  function deleteCookie(name) {
    var host = window.location.hostname;
    var parts = host.split('.');
    var domains = ['', host, '.' + host];
    for (var i = 1; i < parts.length - 1; i++) { domains.push('.' + parts.slice(i).join('.')); }
    domains.forEach(function (domain) {
      document.cookie = name + '=; Max-Age=0; Path=/' + (domain ? '; Domain=' + domain : '');
    });
  }

  function cleanup(category) {
    var patterns = CLEANUP[category];
    if (!patterns) { return; }
    document.cookie.split(';').forEach(function (pair) {
      var name = pair.split('=')[0].trim();
      if (patterns.some(function (pattern) { return pattern.test(name); })) { deleteCookie(name); }
    });
  }

  /* ---------------------------------------------------------------------------------------------------------------
   * Weitergabe der Auswahl: Shopify, Google Consent Mode, blockierte Skripte
   * ------------------------------------------------------------------------------------------------------------- */

  function withShopify(callback) {
    var done = false;
    function finish(customerPrivacy) {
      if (done) { return; }
      done = true;
      callback(customerPrivacy || null);
    }
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy && shopify.customerPrivacy.setTrackingConsent) {
      return finish(shopify.customerPrivacy);
    }
    if (!shopify || typeof shopify.loadFeatures !== 'function') { return finish(null); }
    window.setTimeout(function () { finish(null); }, 1500);
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        finish(error ? null : window.Shopify.customerPrivacy);
      });
    } catch (e) {
      finish(null);
    }
  }

  function sendToShopify(consent) {
    withShopify(function (customerPrivacy) {
      if (!customerPrivacy) { return; }
      try {
        customerPrivacy.setTrackingConsent({
          analytics: consent.analytics,
          marketing: consent.marketing,
          preferences: consent.preferences,
          sale_of_data: consent.marketing
        }, function () {});
      } catch (e) {}
    });
  }

  function sendToGoogle(consent) {
    gtag('consent', 'update', {
      ad_storage: state(consent.marketing),
      ad_user_data: state(consent.marketing),
      ad_personalization: state(consent.marketing),
      analytics_storage: state(consent.analytics),
      functionality_storage: state(consent.preferences),
      personalization_storage: state(consent.preferences)
    });
    gtag('set', 'ads_data_redaction', !consent.marketing);
    window.dataLayer.push({
      event: 'sj_consent_update',
      sj_consent: { preferences: consent.preferences, analytics: consent.analytics, marketing: consent.marketing }
    });
  }

  function releaseBlocked() {
    var scripts = document.querySelectorAll('script[type="text/plain"][data-sj-consent]');
    Array.prototype.forEach.call(scripts, function (blocked) {
      if (!api.allowed(blocked.getAttribute('data-sj-consent'))) { return; }
      var script = document.createElement('script');
      Array.prototype.forEach.call(blocked.attributes, function (attribute) {
        if (attribute.name === 'type' || attribute.name === 'data-sj-consent') { return; }
        script.setAttribute(attribute.name === 'data-type' ? 'type' : attribute.name, attribute.value);
      });
      if (!blocked.getAttribute('src')) { script.text = blocked.text; }
      blocked.parentNode.replaceChild(script, blocked);
    });

    var frames = document.querySelectorAll('iframe[data-sj-consent][data-src]');
    Array.prototype.forEach.call(frames, function (frame) {
      if (!api.allowed(frame.getAttribute('data-sj-consent'))) { return; }
      frame.setAttribute('src', frame.getAttribute('data-src'));
      frame.removeAttribute('data-src');
    });

    api._queue = api._queue.filter(function (entry) {
      if (!api.allowed(entry[0])) { return true; }
      try { entry[1](); } catch (e) {}
      return false;
    });
  }

  function announce() {
    try {
      document.dispatchEvent(new CustomEvent('sj:consent', {
        detail: { preferences: api.consent.preferences, analytics: api.consent.analytics, marketing: api.consent.marketing }
      }));
    } catch (e) {}
  }

  /**
   * Übernimmt eine Auswahl. "silent" = Auswahl stammt aus Shopify (z. B. vom bisherigen Banner) und wird nur gespiegelt.
   */
  function apply(consent, silent) {
    var revoked = CATEGORIES.filter(function (category) { return api.consent[category] && !consent[category]; });

    CATEGORIES.forEach(function (category) { api.consent[category] = !!consent[category]; });
    api.decided = true;
    api.timestamp = Date.now();

    persist(api.consent);
    sendToGoogle(api.consent);
    if (!silent) { sendToShopify(api.consent); }
    revoked.forEach(cleanup);
    releaseBlocked();
    announce();
    updateFab();
    releasePopups(silent ? 0 : parseFloat(root.getAttribute('data-popup-delay')) || 0);

    /* Bereits geladene Skripte lassen sich nicht entladen – nach einem Widerruf wird die Seite neu geladen. */
    if (revoked.length && !designMode) {
      window.setTimeout(function () { window.location.reload(); }, 400);
    }
  }

  /* ---------------------------------------------------------------------------------------------------------------
   * Klaviyo-Popups: bleiben unsichtbar, solange der Besucher im Banner noch nicht entschieden hat
   * ------------------------------------------------------------------------------------------------------------- */

  var scrollLockObserver = null;

  function unlockScroll() {
    if (document.body.classList.contains(KLAVIYO_SCROLL_LOCK)) { document.body.classList.remove(KLAVIYO_SCROLL_LOCK); }
  }

  function holdPopups() {
    if (!document.documentElement.classList.contains(PENDING) || scrollLockObserver) { return; }
    /* Ein verstecktes Popup darf die Seite nicht sperren (wichtig auf Impressum/Datenschutz, wo der Banner nicht blockiert) */
    unlockScroll();
    scrollLockObserver = new MutationObserver(unlockScroll);
    scrollLockObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function releasePopups(delaySeconds) {
    if (!document.documentElement.classList.contains(PENDING)) { return; }
    window.setTimeout(function () {
      if (scrollLockObserver) { scrollLockObserver.disconnect(); scrollLockObserver = null; }
      document.documentElement.classList.remove(PENDING);
      if (document.querySelector('[data-kl-scroll-locking-modal="true"]')) { document.body.classList.add(KLAVIYO_SCROLL_LOCK); }
    }, Math.max(0, delaySeconds) * 1000);
  }

  /* ---------------------------------------------------------------------------------------------------------------
   * Oberfläche
   * ------------------------------------------------------------------------------------------------------------- */

  function show(dialog, modal) {
    if (dialog.open) { return; }
    if (modal && typeof dialog.showModal === 'function') {
      dialog.showModal();
      dialog.focus();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function hide(dialog) {
    if (!dialog.open) { return; }
    if (typeof dialog.close === 'function') { dialog.close(); } else { dialog.removeAttribute('open'); }
  }

  function showBanner() {
    hide(prefs);
    show(banner, bannerIsModal);
  }

  function openPrefs() {
    lastFocus = document.activeElement;
    Array.prototype.forEach.call(prefs.querySelectorAll('[data-sj-toggle]'), function (toggle) {
      toggle.checked = !!api.consent[toggle.getAttribute('data-sj-toggle')];
    });
    hide(banner);
    show(prefs, true);
    prefs.scrollTop = 0;
  }

  function closePrefs() {
    hide(prefs);
    if (!api.decided) {
      showBanner();
    } else if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus();
    }
  }

  function updateFab() {
    if (!fab) { return; }
    var forced = fab.getAttribute('data-sj-fab') === 'always';
    var hasOtherOpener = Array.prototype.some.call(document.querySelectorAll(OPENERS), function (element) {
      return element !== fab;
    });
    fab.hidden = !(api.decided && (forced || !hasOtherOpener));
  }

  function decide(action) {
    var consent = { preferences: false, analytics: false, marketing: false };
    if (action === 'accept') {
      consent = { preferences: true, analytics: true, marketing: true };
    } else if (action === 'save') {
      Array.prototype.forEach.call(prefs.querySelectorAll('[data-sj-toggle]'), function (toggle) {
        consent[toggle.getAttribute('data-sj-toggle')] = toggle.checked;
      });
    }
    hide(banner);
    hide(prefs);
    apply(consent, false);
  }

  root.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-sj-action]');
    if (!trigger) { return; }
    var action = trigger.getAttribute('data-sj-action');
    if (action === 'settings') { openPrefs(); }
    else if (action === 'close') { closePrefs(); }
    else { decide(action); }
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest(OPENERS);
    if (!opener) { return; }
    event.preventDefault();
    openPrefs();
  });

  /* Escape: der Einstellungsdialog schließt sich, das Banner bleibt bis zu einer Entscheidung stehen. */
  banner.addEventListener('cancel', function (event) { event.preventDefault(); });
  /* Escape soll ein zurückgehaltenes Popup nicht ungesehen schließen */
  root.addEventListener('keydown', function (event) { if (event.key === 'Escape') { event.stopPropagation(); } });
  banner.addEventListener('close', function () {
    if (!api.decided && !prefs.open) { window.setTimeout(showBanner, 0); }
  });
  prefs.addEventListener('cancel', function (event) { event.preventDefault(); closePrefs(); });
  prefs.addEventListener('click', function (event) { if (event.target === prefs) { closePrefs(); } });

  /* ---------------------------------------------------------------------------------------------------------------
   * Start
   * ------------------------------------------------------------------------------------------------------------- */

  api.open = openPrefs;
  api.accept = function () { decide('accept'); };
  api.reject = function () { decide('reject'); };

  releaseBlocked();
  updateFab();
  holdPopups();

  withShopify(function (customerPrivacy) {
    var current = null;
    try { current = customerPrivacy ? customerPrivacy.currentVisitorConsent() : null; } catch (e) {}

    if (!api.decided && current && (current.analytics || current.marketing || current.preferences)) {
      /* Besucher hat bereits entschieden (frühere Sitzung oder bisheriges Banner) – Auswahl übernehmen statt neu fragen */
      apply({
        preferences: current.preferences === 'yes',
        analytics: current.analytics === 'yes',
        marketing: current.marketing === 'yes'
      }, true);
    } else if (api.decided && customerPrivacy) {
      var differs = !current || CATEGORIES.some(function (category) {
        return current[category] !== (api.consent[category] ? 'yes' : 'no');
      });
      if (differs) { sendToShopify(api.consent); }
    }

    if (!api.decided || designMode) { showBanner(); }
  });
})();
